const STRIPE_JS_SRC = 'https://js.stripe.com/v3/';
let stripeLoadPromise = null;

/**
 * Resolves once the global `Stripe` (Stripe.js v3) is available, injecting the
 * script tag if needed. Memoized so concurrent callers share a single load.
 *
 * The card Elements can only be created after Stripe.js has finished loading; a
 * present-but-still-loading script tag is not enough, so always wait for its
 * load event rather than assuming the tag's presence means readiness.
 *
 * @returns {Promise<void>}
 */
export const ensureStripeLoaded = () => {
	if (typeof window !== 'undefined' && window.Stripe) {
		return Promise.resolve();
	}

	if (stripeLoadPromise) {
		return stripeLoadPromise;
	}

	stripeLoadPromise = new Promise((resolve, reject) => {
		let script = document.querySelector(`script[src="${STRIPE_JS_SRC}"]`);

		if (!script) {
			script = document.createElement('script');
			script.src = STRIPE_JS_SRC;
			document.head.appendChild(script);
		}

		script.addEventListener('load', () => resolve(), { once: true });
		script.addEventListener('error', () => {
			// Clear the memo so a later call can retry instead of reusing the rejection.
			stripeLoadPromise = null;
			reject(new Error('Failed to load Stripe.js'));
		}, { once: true });
	});

	return stripeLoadPromise;
};
